import { render, staticRenderFns } from "./simulacao-seguro-viagem.html?vue&type=template&id=32d0214c&scoped=true&"
import script from "./simulacao-seguro-viagem.js?vue&type=script&lang=js&"
export * from "./simulacao-seguro-viagem.js?vue&type=script&lang=js&"
import style0 from "./simulacao-seguro-viagem.scss?vue&type=style&index=0&id=32d0214c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d0214c",
  null
  
)

export default component.exports